import { Directive } from "@angular/core";

import { Base } from "./base";

@Directive()
export abstract class BaseService extends Base {
    constructor() {
        super();
        this.log.debug("Service initialized");
    }
}
